import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'element-ui/lib/theme-chalk/index.css'
import './common/styles/override.scss'
import './common/styles/public.scss'
import {BootstrapVue} from 'bootstrap-vue'
import Element from 'element-ui'
import Main from './common/views/main.vue'
import Inject from './common/scripts/inject'
import router from './common/scripts/router'

Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(Element)
Vue.use(Inject)

new Vue({
  router,
  render: h => h(Main)
}).$mount('#app')
